export default __webpack_public_path__ + "static/media/loader-inf.0ccecbfc.gif";